import { render, staticRenderFns } from "./propertyConfig.vue?vue&type=template&id=5cedd88d&scoped=true&"
import script from "./propertyConfig.vue?vue&type=script&lang=js&"
export * from "./propertyConfig.vue?vue&type=script&lang=js&"
import style0 from "./propertyConfig.vue?vue&type=style&index=0&id=5cedd88d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cedd88d",
  null
  
)

export default component.exports